import { render, staticRenderFns } from "./ProfilePreview.vue?vue&type=template&id=3c673f80&scoped=true&"
import script from "./ProfilePreview.vue?vue&type=script&lang=js&"
export * from "./ProfilePreview.vue?vue&type=script&lang=js&"
import style0 from "./ProfilePreview.vue?vue&type=style&index=0&id=3c673f80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c673f80",
  null
  
)

export default component.exports